function toFullWidth(str) {
    return str.replace(/[\u0020-\u007E]/g, (char) => String.fromCharCode(char.charCodeAt(0) + 0xfee0)).replace(/ /g, '　');
}

function toKatakana(str) {
    return str.replace(/[\u3041-\u3096]/g, (char) => String.fromCharCode(char.charCodeAt(0) + 0x60));
}

function toHiragana(str) {
    return str.replace(/[\u30A1-\u30F6]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0x60));
}

function halfwidthKanaToFullwidthKana(str) {
    const kanaMap = {
        ｱ: 'ア',
        ｲ: 'イ',
        ｳ: 'ウ',
        ｴ: 'エ',
        ｵ: 'オ',
        ｶ: 'カ',
        ｷ: 'キ',
        ｸ: 'ク',
        ｹ: 'ケ',
        ｺ: 'コ',
        ｻ: 'サ',
        ｼ: 'シ',
        ｽ: 'ス',
        ｾ: 'セ',
        ｿ: 'ソ',
        ﾀ: 'タ',
        ﾁ: 'チ',
        ﾂ: 'ツ',
        ﾃ: 'テ',
        ﾄ: 'ト',
        ﾅ: 'ナ',
        ﾆ: 'ニ',
        ﾇ: 'ヌ',
        ﾈ: 'ネ',
        ﾉ: 'ノ',
        ﾊ: 'ハ',
        ﾋ: 'ヒ',
        ﾌ: 'フ',
        ﾍ: 'ヘ',
        ﾎ: 'ホ',
        ﾏ: 'マ',
        ﾐ: 'ミ',
        ﾑ: 'ム',
        ﾒ: 'メ',
        ﾓ: 'モ',
        ﾔ: 'ヤ',
        ﾕ: 'ユ',
        ﾖ: 'ヨ',
        ﾗ: 'ラ',
        ﾘ: 'リ',
        ﾙ: 'ル',
        ﾚ: 'レ',
        ﾛ: 'ロ',
        ﾜ: 'ワ',
        ｦ: 'ヲ',
        ﾝ: 'ン',
        ｧ: 'ァ',
        ｨ: 'ィ',
        ｩ: 'ゥ',
        ｪ: 'ェ',
        ｫ: 'ォ',
        ｬ: 'ャ',
        ｭ: 'ュ',
        ｮ: 'ョ',
        ｯ: 'ッ',
        ｰ: 'ー',
        '｡': '。',
        '｢': '「',
        '｣': '」',
        '､': '、',
        '･': '・'
    };

    return str
        .split('')
        .map((c) => kanaMap[c] || c)
        .join('');
}

function normalizeKeywordPattern(str, options = {}) {
    let result = str;

    if (!options.fullHalfWidth) {
        result = toFullWidth(result);
        result = halfwidthKanaToFullwidthKana(result); // 👈 THÊM DÒNG NÀY
    }

    if (!options.kanaSensitive) {
        result = toKatakana(toHiragana(result));
    }

    if (!options.caseSensitive) {
        result = result.toLowerCase();
    }

    return result;
}

function checkKeywordPattern(input, keyword, options = {}) {
    const listKeyword = keyword.split('\n');
    const normalizedInput = normalizeKeywordPattern(input, options);
    for (let i = 0; i < listKeyword.length; i++) {
        const normalizedKeyword = normalizeKeywordPattern(listKeyword[i], options);
        if (normalizedInput === normalizedKeyword) return true;
    }
}

export { checkKeywordPattern };
